/**
 * Portfolio component
 *
 * Highlights some of  your creations. These can be designs, websites,
 * open source contributions, articles you've written and more.
 *
 * This is a great area for you to to continually add to and refine
 * as you continue to learn and create.
 */

import React from "react";

/**
 * Desk image
 *
 * Below is a sample desk image. Feel free to update this to an image of your choice,
 * updating below imageAltText to string that represents what you see in that image.
 *
 * Need an image? Check out https://unsplash.com to download a photo you
 * freely use on your site.
 */
import image from "url:../images/design-desk.jpeg";

const imageAltText = "desktop with books and laptop";

/**
 * Project list
 *
 * An array of objects that will be used to display for your project
 * links section. Below is a sample, update to reflect links you'd like to highlight.
 */
const projectList = [
  {
    title: "Twilight Imperium 4 — Faction Build Calculator 🌌",
    description:
      "A passion project born from countless hours of epic galactic conquest. This tool helps TI4 players plan and optimize their faction builds before the game starts. Because winning the galaxy deserves preparation.",
    url: "https://coffee-marcile-94.tiiny.site/",
  },
  {
    title: "This Portfolio Website",
    description:
      "Built from scratch with React and deployed on Azure Static Web Apps, featuring an AI-powered chatbot backed by Azure AI Projects. The whole stack is open source.",
    url: "https://github.com/ymandjee/cs-ymandjeedotcom",
  },
];

const Portfolio = () => {
  return (
    <section className="padding" id="portfolio">
      <h2 style={{ textAlign: "center", color: "var(--text)" }}>Portfolio</h2>
      <div className="portfolio-layout">
        <div className="portfolio-image">
          <img
            src={image}
            style={{ height: "90%", width: "100%", objectFit: "cover" }}
            alt={imageAltText}
          />
        </div>
        <div className="container">
          {projectList.map((project) => (
            <div className="box" key={project.title}>
              <a href={project.url} target="_blank" rel="noopener noreferrer">
                <h3 style={{ flexBasis: "40px" }}>{project.title}</h3>
              </a>
              <p className="small">{project.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
